<template>
  <div class="onlineReserve-add">
    <van-row type="flex" justify="center" class="row-title">
      <van-col span="24" class="col-title">
        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="friends-o">
          不动产网上预约
        </van-notice-bar>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-show">
      <van-col span="23" class="col-show">
        <van-panel title="预约窗口说明" desc="预约窗口对应可办理的事项" status="请知悉">
          <div class="reser-content">
            <p v-for="businessWindow in allBusinessWindowList" :key="businessWindow.id" :value="businessWindow.id">
              {{ businessWindow.name }}: {{ businessWindow.description }}
            </p>
          </div>
        </van-panel>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-tip">
      <van-col span="24" class="col-tip">
        <van-divider
          :style="{ color: '#999', borderColor: '#999', padding: '0 16px' }"
        >
          预约信息
        </van-divider>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field
          v-model="netWorkName"
          v-validate="{required:true}"
          readonly
          clickable
          name="picker"
          label="预约网点"
          placeholder="点击选择预约网点"
          :rules="[{ required: true, message: '请选择预约网点' }]"
          @click="showNetworkPicker = true"
        />
        <van-popup v-model="showNetworkPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="allBusinessNetworkList"
            @confirm="onNetworkConfirm"
            @cancel="showNetworkPicker = false"
          />
        </van-popup>
        <van-field
          v-model="windowName"
          readonly
          clickable
          name="picker"
          label="预约窗口"
          placeholder="点击选择预约窗口"
          @click="showWindowPicker = true"
        />
        <van-popup v-model="showWindowPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="businessWindowList"
            @confirm="onWindowConfirm"
            @cancel="showWindowPicker = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="calendar"
          :value="reserveDate"
          label="预约日期"
          placeholder="只能预约未来五个工作日111"
          @click="showCalendar = true"
        />
        <van-calendar v-model="showCalendar" @confirm="onDateConfirm" />
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="reserveTime"
          label="预约时间"
          placeholder="每30分钟一间隔"
          @click="showTimePicker = true"
        />
        <van-popup v-model="showTimePicker" position="bottom">
          <van-datetime-picker
            type="time"
            :filter="filterTime"
            @confirm="onTimeConfirm"
            @cancel="showTimePicker = false"
          />
        </van-popup>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-button">
      <van-col span="22" class="col-button">
        <van-button round block type="info" native-type="submit" @click="handleSubmit()">
          确认预约
        </van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script type="text/javascript">
import { getSystemConfig } from '@/api/systemConfig.js'
import { getBusinessWindowList, getBusinessWindowById } from '@/api/businessWindow'
import { getBusinessNetworkList } from '@/api/businessNetwork'
import { Notify, Toast } from 'vant'
import { addOnlineReserve } from '@/api/onlineReserve'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      dJXT_QXMC: '',
      dJXT_LXDH: '',
      checkbox: false,
      checkboxGroup: [],
      businessWindowList: [], // 根据业务网点获取业务窗口列表
      allBusinessNetworkList: [], // 获取业务网点列表
      netWorkName: '',
      windowName: '',
      reserveDate: '',
      showNetworkPicker: false,
      showWindowPicker: false,
      formOnlineReserve: {
        businessNetworkId: '',
        businessWindowId: '',
        reserveDate: '',
        reserveTime: '',
        reserveEndTime: '',
        webUserId: '',
        webUser: null,
        businessWindow: null,
        formatDate: ''
      },
      showCalendar: false,
      reserveTime: '',
      showTimePicker: false,
      allBusinessWindowList: [] // 获取所有的窗口列表
    }
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  mounted() {
    this.selectAllbusinessWindow()
    this.loadSystemConfig()
    this.selectBusinessNetwork()
  },
  methods: {
    loadSystemConfig() {
      getSystemConfig({ key: 'DJXT_QXMC' }).then(response => {
        this.dJXT_QXMC = response.data.value
      })
      getSystemConfig({ key: 'DJXT_LXDH' }).then(response => {
        this.dJXT_LXDH = response.data.value
      })
    },
    selectAllbusinessWindow() {
      getBusinessWindowList().then(response => {
        this.allBusinessWindowList = response.data
      })
    },
    onNetworkConfirm(netWork) {
      this.netWorkName = netWork.text
      this.showNetworkPicker = false
      if (netWork.value != null) {
        this.formOnlineReserve.businessNetworkId = netWork.value
        getBusinessWindowList({ businessNetworkId: netWork.value }).then(response => {
          response.data.forEach(element => {
            this.businessWindowList.push({
              text: element.name,
              value: element.id
            })
          })
        })
      }
    },
    selectBusinessNetwork() {
      getBusinessNetworkList().then(response => {
        response.data.forEach(element => {
          this.allBusinessNetworkList.push({
            text: element.name,
            value: element.id
          })
        })
        this.formOnlineReserve.webUser = this.webUserInfo
        this.formOnlineReserve.webUserId = this.webUserInfo.id
      })
    },
    onWindowConfirm(window) {
      this.windowName = window.text
      this.showWindowPicker = false
      this.formOnlineReserve.businessWindowId = window.value
      getBusinessWindowById(window.value).then(
        response => {
          this.formOnlineReserve.businessWindow = response.data
        }
      )
    },
    onDateConfirm(date) {
      this.reserveDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
      this.formOnlineReserve.reserveDate = this.reserveDate
      this.showCalendar = false
    },
    onTimeConfirm(time) {
      this.reserveTime = time
      this.formOnlineReserve.reserveTime = time
      this.showTimePicker = false
    },
    filterTime(type, options) {
      if (type === 'hour') {
        return ['09', '10', '11', '12', '13', '14', '15', '16']
      }
      if (type === 'minute') {
        return ['00', '30']
      }
      return options
    },
    handleSubmit() {
      if (!this.netWorkName || !this.windowName || !this.formOnlineReserve.reserveDate || !this.formOnlineReserve.reserveTime) {
        Toast.fail('内容不能为空')
        Notify({ type: 'danger', message: '请填写完整预约信息' })
        return
      }
      Toast.loading({
        message: '提交中...',
        forbidClick: true
      })
      this.formOnlineReserve.formatDate = this.formOnlineReserve.reserveDate
      this.formatTimeOnline()
      addOnlineReserve(this.formOnlineReserve)
        .then(response => {
          Notify({ type: 'success', message: '在线预约操作成功！' })
          Toast.clear()
          setTimeout(() => {
            // 跳转页面
            this.$router.push({
              path: '/'
            })
          }, 1000)
        })
        .catch(error => {
          console.log(error)
          Toast.fail('提交失败')
          Notify({ type: 'danger', message: '重复提交在线预约信息' })
        })
    },
    formatTimeOnline() {
      var hh = parseInt(this.formOnlineReserve.reserveTime.substring(0, 2))
      var mm = parseInt(this.formOnlineReserve.reserveTime.substring(3, 5))
      if (mm === 0) {
        if (hh.toString().length === 1) {
          hh = '0' + hh.toString()
          this.formOnlineReserve.reserveEndTime = hh + ':' + '30'
        } else {
          this.formOnlineReserve.reserveEndTime = hh.toString() + ':' + '30'
        }
      } else {
        hh = hh + 1
        if (hh.toString().length === 1) {
          hh = '0' + hh.toString()
          this.formOnlineReserve.reserveEndTime = hh + ':' + '00'
        } else {
          this.formOnlineReserve.reserveEndTime = hh.toString() + ':' + '00'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .onlineReserve-add{
    min-height: 100vh;
    background-color: #F1F0F8;
    .col-tip{
      p{
        margin-left: 5px;
        font-weight: bold;
        font-size: 0.8em;
      }
    };
    .row-button{
      margin-top: 20px;
    }
    .row-show{
      margin-top: 16px;
      .col-show{
        .reser-content{
          padding: 5px 0;
          p{
            margin: 0 16px 0;
            font-size: 0.8em;
            color: #666;
          }
        }
      }
    }
    .row-button{
      margin-top: 50px;
    }
  }
